module.exports = __webpack_public_path__ + "img/4-5.170d960e.svg";